'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = function (ComposedComponent) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits3.default)(WithMessage, _React$Component);

    function WithMessage() {
      (0, _classCallCheck3.default)(this, WithMessage);
      return (0, _possibleConstructorReturn3.default)(this, (WithMessage.__proto__ || Object.getPrototypeOf(WithMessage)).apply(this, arguments));
    }

    (0, _createClass3.default)(WithMessage, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, { showMessage: this.context.showMessage }));
      }
    }]);
    return WithMessage;
  }(_react2.default.Component), _class.contextTypes = {
    showMessage: _propTypes2.default.func.isRequired
  }, _temp;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/decorators/withMessage.js
// module id = 245
// module chunks = 85